import { Display } from "../../../Models/Display";

export const responsiveCustomDatas = (display: Display) => {
  return {
    cells: {
      icon: { gridArea: "icon" },
      description: { gridArea: "description" },
      unitWeight: { gridArea: "unitWeight" },
      unitPrice: { gridArea: "unitPrice" },
      hsCode: { gridArea: "hsCode" },
      countryIsoCode2: { gridArea: "countryIsoCode2" },
      quantity: { gridArea: "quantity" },
      totalQuantity: { gridArea: "totalQuantity" },
      totalWeight: { gridArea: "totalWeight" },
      totalPrice: { gridArea: "totalPrice" },
    },

    // GRID Header
    header: {
      display: "grid",
      gridTemplateColumns: "0.35fr 1fr 1fr 1fr 1fr 1fr 1fr",
      gridTemplateAreas: `
        ". description unitWeight unitPrice hsCode countryIsoCode2 quantity"
      `,
    },

    // GRID Main
    listItem: {
      display: "grid",
      gridTemplateColumns: display.xs
        ? "1fr"
        : display.sm
          ? "1fr 1fr"
          : display.md
            ? "1fr 1fr 1fr"
            : "0.35fr 1fr 1fr 1fr 1fr 1fr 1fr",
      gridTemplateAreas: display.xs
        ? `
          "icon"
          "description"
          "unitWeight"
          "unitPrice"
          "hsCode"
          "countryIsoCode2"
          "quantity"
        `
        : display.sm
          ? `
          "icon icon"
          "description unitWeight"
          "unitPrice hsCode"
          "countryIsoCode2 quantity"
        `
          : display.md
            ? `
          "icon icon icon"
          "description unitWeight unitPrice"
          "hsCode countryIsoCode2 quantity"
        `
            : `
          "icon description unitWeight unitPrice hsCode countryIsoCode2 quantity"
        `,
    },

    // GRID Footer
    footer: {
      display: "grid",
      gridTemplateColumns: display.xs
        ? "1fr"
        : display.sm
          ? "1fr 1fr"
          : display.md
            ? "1fr 1fr 1fr"
            : "2fr 1fr 1fr 1fr 1fr 1fr",
      gridTemplateAreas: display.xs
        ? `
        "totalQuantity"
        "totalWeight"
        "totalPrice"
        `
        : display.sm
          ? `
        "totalQuantity totalQuantity"
        "totalWeight totalPrice"
        `
          : display.md
            ? `
        "totalQuantity totalWeight totalPrice"
        `
            : `
        ". . . totalQuantity totalWeight totalPrice"
        `,
    },
  };
};
